import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { OneLPSsdkParamsContext } from '../../../onelps-sdk-params-context';


function CreditsLink({ label, linkId, linkUrl }) {
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const creditsUrl = 'https://' + onelpsParams.marketId + linkUrl;

	return (
		<a
			href={creditsUrl}
			target="_blank"
			id={linkId}
			rel="noreferrer"
		>
			{ label }
		</a>
	);
}

export default CreditsLink;

CreditsLink.propTypes = {
	label: PropTypes.string.isRequired,
	linkId: PropTypes.string,
	linkUrl: PropTypes.string,
};

CreditsLink.defaultProp = {
	linkId: 'n/a',
};
